export const API_ADDRESS = "https://evmodeapi.easyhost.kr/api"
